"use client";

import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import { useJwtToken } from "@website/hooks/auth-manager";
import { getTracking } from "@website/store/tracking";
import { getChannel } from "@website/utils/channel/get-channel";
import { useEffect } from "react";

const growthbook = new GrowthBook({
  enabled: true,
  apiHost: process.env.NEXT_PUBLIC_BASE_URL_GPI,
  clientKey: "sdk-vZPPyJiVMsLPslBK",
  enableDevMode: true,
  subscribeToChanges: true
});

growthbook.init({
  streaming: true
});

export const GrowthBookWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const { aid } = getTracking();
  const { sub: userId } = useJwtToken();

  useEffect(() => {
    growthbook.setAttributes({
      id: aid,
      userId,
      Channel: getChannel()
    });
  }, [aid]);

  return (
    <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>
  );
};

export default GrowthBookWrapper;
